module.exports = __webpack_public_path__ + "img/df03693.png";